import { Box, Button, CircularProgress, Stack, Typography } from "@mui/material";
import MaterialModal from "../../app/material-modal";
import { useKeycloak } from "@react-keycloak/web";
import { useQueryClient } from "@tanstack/react-query";
import { useDeleteGroup } from "../../../tanstackQuery/queries/superAdmin/group";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { INITIAL_S_ADMIN_IN_ATOM_VALUE, SAdminBaseAtom } from "../../../stores/jotai/super-admin/superAdminBase";
import { useAtom } from "jotai";
import { baseAtom } from "../../../stores/jotai/base";

export const DeleteGroupConfrimModal = ({ open, handleClose }) => {
  const [sAdminBase,setSAdminBase]=useAtom(SAdminBaseAtom);
  const [base,setBase]=useAtom(baseAtom);

  const {group}=sAdminBase?.deleteGroupDataInfo;

  const { keycloak } = useKeycloak();
  const client = useQueryClient();
  const navigate=useNavigate();

  const {
    mutateAsync: deleteGroup,
    isPending,
    isSuccess,
  } = useDeleteGroup(
    { accessToken: keycloak?.token },
    {
      onSuccess: () => {
        client.invalidateQueries({ queryKey: ["orgtree"] });
        handleClose();
        navigate(`/admin/`);
        setSAdminBase(prev => ({...prev, deleteGroupDataInfo:INITIAL_S_ADMIN_IN_ATOM_VALUE?.deleteGroupDataInfo}));
      },
    }
  );

  const deleteNode = async () => {
    try {
      await deleteGroup(group?.groupID);
      if (isSuccess) {
        toast.success("Group successfully deleted!");
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Failed to delete group.");
    }
  }

  return (
    <MaterialModal
      title={`Delete ${group?.groupType}`}
      open={open}
      onClose={handleClose}
      handleDialogClose={handleClose}
      styleOverrides={{
        container: {
          "& .MuiDialog-paper": {
            width: "100%",
            minWidth: "300px",
            minHeight: "200px",
          },
        },
      }}
    >
      <Box>
        {
          base?.team?.groupID===group?.groupID ? <Typography variant="subtitle1">
            You can't delete this <strong>team</strong>, Currently your organization is being loaded with this team,
            <strong>Switch team from Home page </strong>{" "}and try again.
          </Typography> : <Typography variant="subtitle1">
            Are you sure you want to permanently delete the{" "}
            <strong> {group?.name} </strong>{" "} {group?.groupType}? {" "}
            This action will remove all associated information and cannot be
            undone.
          </Typography>
        }

        <Stack direction="row" justifyContent="flex-end" gap={1} mt={2}>
          <Button variant="outlined" onClick={handleClose}>
            No
          </Button>
          <Button
            disabled={isPending || (base?.team?.groupID===group?.groupID)}
            variant="contained"
            onClick={() => deleteNode()}
            endIcon={ isPending ? ( <CircularProgress size={15} color="primary" /> ) : null }
          >
            Yes
          </Button>
        </Stack>
      </Box>
    </MaterialModal>
  );
};